<app-loader [isLoading]="isLoading"></app-loader>

<div class="popup-container d-flex flex-column">
  <div class="d-flex justify-content-between align-items-center">
    <span class="heading-text">Merge FC</span>
    <div class="img-container" mat-dialog-close>
      <img
        src="../../../assets/images/crossIconDarkTheme.svg"
        class="cross-icon"
      />
    </div>
  </div>
  <div class="content-div d-flex flex-column">
    <div class="details d-flex justify-content-between">
      <span class="detail-heading"> Serial No.</span>
      <span class="detail-text">{{ data.slNo }}</span>
    </div>
    <div class="details d-flex justify-content-between">
      <span class="detail-heading"> Name</span>
      <span class="detail-text">{{ data.resData.mem_full_name }}</span>
    </div>
    <div class="details d-flex justify-content-between">
      <span class="detail-heading"> Philanthropy Name</span>
      <span class="detail-text"
        >{{ data.resData.phl_mem_name }}&nbsp;{{
          data.resData.phl_mem_surname
        }}</span
      >
    </div>
    <div class="details d-flex justify-content-between">
      <span class="detail-heading">Guardian Name</span>
      <span class="detail-text">{{ data.resData.mem_guardian_name }}</span>
    </div>
    <div class="details d-flex justify-content-between">
      <span class="detail-heading"> Ritwik Name</span>
      <span class="detail-text">{{ data.resData.mem_ritwiki_name }}</span>
    </div>
    <div class="details d-flex justify-content-between">
      <span class="detail-heading"> Last Istavrity Date</span>
      <span class="detail-text">{{ data.resData.last_istavrity_date }}</span>
    </div>
    <div class="details d-flex justify-content-between">
      <span class="detail-heading">Family Code</span>

      <span class="detail-text">{{ data.resData.mem_family_code }}</span>
    </div>

    <div class="details d-flex justify-content-between">
      <span class="detail-heading"> Address</span>
      <span class="detail-text">{{ data.resData.address }}</span>
    </div>
  </div>
  <form (submit)="onSearch()">
    <div class="input-div">
      <input
        type="tel"
        class="dp-input-control input-content"
        placeholder="Enter FC code to merge"
        [formControl]="searchReq"
        (keydown)="restrictFCInput($event)"
        [matAutocomplete]="auto"
      />
    </div>

    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
      @for (item of fcDetails ; track item;) {
      <mat-option (click)="onSelectFCDropDown(item)">
        <div class="d-flex justify-content-between">
          <span class="name-min-width">
            {{ item.mem_name }}&nbsp;&nbsp;{{ item.mem_surname }}
          </span>
        </div> </mat-option
      >}
    </mat-autocomplete>
  </form>

  @for(item of fcData;track item){
  <div class="fc-div d-flex flex-column">
    <div class="details d-flex justify-content-between">
      <span class="detail-heading"> Family Code </span>
      <span class="detail-text">{{ item.family_code }}</span>
    </div>
    <!-- <div class="details d-flex justify-content-between">
      <span class="detail-heading"> Full Name</span>
      <span class="detail-text"
        >{{ item.mem_full_name }}</span
      >
    </div> -->
    <div class="details d-flex justify-content-between">
      <span class="detail-heading">Philanthropy Full Name</span>
      <span class="detail-text"
        >{{ item.phl_mem_name }}&nbsp;{{ item.phl_mem_surname }}</span
      >
    </div>
    <div class="details d-flex justify-content-between">
      <span class="detail-heading">Merge Status</span>
      <span class="detail-text">{{ item.status }}</span>
    </div>
    @if(item.added){
    <button class="merge-btn" (click)="onDeleteClick($index)">
      <img src="../../../assets/images/delete-black.svg" /><span class="btn-txt"
        >Delete this code</span
      >
    </button>
    }
  </div>
  } @if(mergeReqCount>0){
  <button class="dp-primary-btn merge-code-btn" (click)="mergeClick()">
    Merge Codes
  </button>
  }
</div>
